// @ts-strict

import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html'
})
export class DocumentViewerComponent {
  documentUrl?: SafeResourceUrl;

  constructor(private route: ActivatedRoute, private sanitizer: DomSanitizer) {
    this.route.data.subscribe((data: { asset: Blob }) => {
      // You can display the document in your component.
      // Here you have access to the document's binary data in data.asset.
      const blobUrl = URL.createObjectURL(data.asset);
      this.documentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
    });
  }
}
